import React, { PureComponent, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { OptionsPropType } from '../../shared/propTypes/common';
import { SlAdminAccountPropTypes } from './propTypes';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './slAccountForm.schema';

import { periodOrCurrentSelector } from '../../shared/store/selectors';

import {
  fetchInitialDataForSlAccountsAddAndEditModal,
} from './store/actions';

import {
  sharedSelectors,
  slViewOptionsSelector,
  lifecycleMapOptionsSelector,
  isFetchingInitialDataForModalSelector,
} from './store/selectors';

const ModalTitles = {
  ADD: 'Add Account',
  EDIT: 'Edit Account',
};

class AddEditModal extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    entityToEdit: SlAdminAccountPropTypes,

    slViewOptions: OptionsPropType,
    lifecycleMapOptions: OptionsPropType,

    openForEdit: PropTypes.bool.isRequired,

    hideModal: PropTypes.func.isRequired,

    fetchInitialData: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    isFetchingInitialDataForModal: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { period, fetchInitialData } = this.props;

    fetchInitialData(period);
  }

  save = (slAccountData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit } = this.props;

    const payload = ({
      ...slAccountData,
      periodName: period.name,
    });

    const params = {
      periodName: period.name,
      slAccount: slAccountData.slAccount,
    };

    saveEntity(payload, openForEdit, { params, callback: resetForm } );
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      slViewOptions,
      lifecycleMapOptions,
      hideModal,
      isVisible,
      isSavingInProgress,
      isFetchingInitialDataForModal,
    } = this.props;

    const reset = useCallback(() => {
      hideModal();
      formik.resetForm();
    }, [formik, hideModal]);

    return (
      <Modal
        className="add-edit-sl-admin-account-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        isLoading={isFetchingInitialDataForModal}
        submitAction={formik.handleSubmit}
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            slViewOptions,
            lifecycleMapOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  period: periodOrCurrentSelector(state),
  slViewOptions: slViewOptionsSelector(state),
  lifecycleMapOptions: lifecycleMapOptionsSelector(state),
  isSavingInProgress: sharedSelectors.savingEntitySelector(state),
  isFetchingInitialDataForModal: isFetchingInitialDataForModalSelector(state),
});

export default connect(
  mapStateToProps,
  {
    fetchInitialData: fetchInitialDataForSlAccountsAddAndEditModal,
  }
)(AddEditModal);
